// Сжимает строку в Uint8Array.
export async function gzipString(str: string): Promise<Uint8Array> {
    // 1. Convert the string into a byte stream
    const stream = new Blob([str]).stream()

    // 2. Pipe the stream through a gzip compression stream
    const compressedStream = stream.pipeThrough(new CompressionStream('gzip'))

    // 3. Read the compressed data into an ArrayBuffer
    const response = new Response(compressedStream)
    const buffer = await response.arrayBuffer()

    // 4. Return as a Uint8Array
    return new Uint8Array(buffer)
}
